import React from "react";
import Routes from "./Routes";
import ReactDOM from "react-dom";
// import './style/main.scss';
import store from './lib/store';
import { Provider } from 'react-redux'
import Client from "./clients";


const checkVersion = async () => {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`);
    const { version } = await res.json();
    const stored = localStorage.getItem("app_version");

    if (!stored) {
      localStorage.setItem("app_version", version);
      return;
    }

    if (stored !== version) {
      console.log("New version detected, reloading...");
      localStorage.setItem("app_version", version);
      window.location.reload();
    }
  } catch (err) {
    console.error("Version check failed:", err);
  }
};

// Check on initial load
checkVersion();

// Poll every 5 minutes while app is open
setInterval(checkVersion, 5 * 60 * 1000);

ReactDOM.render(
  <Provider store={store}>
    <Routes/>
  </Provider>, 
  document.getElementById("root")
);
